import React, { useEffect, useState, useCallback } from 'react';
import api from '../services/api';
import Modal from './Modal';
import Spinner from './Spinner';
import { toast } from './Toast';
import { exportCSV, printTable } from './ExportButton';

const CATEGORII = [
  { id:'Permis_Auto',     label:'🪪 Permis Auto',      areExpirare:true  },
  { id:'Vizita_Medicala', label:'🩺 Vizite Medicale', areExpirare:true  },
  { id:'ADR',             label:'☢️ Acreditări ADR',   areExpirare:true  },
  { id:'CPC',             label:'📜 Atestat CPC',      areExpirare:true  },
  { id:'Tahograf',        label:'💳 Card Tahograf',    areExpirare:true  },
  { id:'Amenda',          label:'🚨 Amenzi',           areExpirare:false },
];

const CATEGORII_PERMIS = ['AM','A1','A2','A','B1','B','BE','C1','C','C1E','CE','D1','D','D1E','DE','Tr','Tb','Tv'];

const EMPTY = { username:'', nrInmatriculare:'', nrDocument:'', dataDoc:'', dataExpirare:'', valoare:'', descriere:'', inlocuita:'', categoriePermis:'', dataValabilitate:'', termenPlata:'', valoareFinala:'' };

function zileColor(zile) { return zile<0?'tr-expirat':zile<=30?'tr-expira':''; }
function badge(zile) {
  if (zile<0) return <span className="badge badge-danger">Expirat {Math.abs(zile)}z</span>;
  if (zile<=30) return <span className="badge badge-warning">{zile} zile</span>;
  return <span className="badge badge-ok">{zile} zile</span>;
}
function badgeDinData(dataExpirare) {
  if (!dataExpirare) return <span className="badge" style={{background:'#eee',color:'#888'}}>—</span>;
  const zile = Math.round((new Date(dataExpirare)-new Date())/86400000);
  return badge(zile);
}
function FilterInput({ value, onChange }) {
  return <input value={value} onChange={e=>onChange(e.target.value)} placeholder="Filtrează..."
    style={{width:'100%',padding:'3px 6px',fontSize:11,border:'1px solid #ccc',borderRadius:3}}/>;
}
function fmt(val) {
  return parseFloat(val||0).toLocaleString('ro-RO', {minimumFractionDigits:2, maximumFractionDigits:2});
}
function esteInlocuit(r) { return parseInt(r.inlocuita) > 0; }

// Textul de status pentru o categorie de document, pe baza datei de expirare primite de la
// /api/personal/soferi/{username}/detalii — aceeasi logica de "zile ramase" ca in accordion.
function statusTextDinData(dataExpirare) {
  if (!dataExpirare) return { text:'—', culoare:'#888' };
  const zile = Math.round((new Date(dataExpirare)-new Date())/86400000);
  if (zile < 0) return { text:`Expirat de ${Math.abs(zile)} zile (${dataExpirare})`, culoare:'#c0392b' };
  if (zile <= 30) return { text:`Expiră în ${zile} zile (${dataExpirare})`, culoare:'#b8860b' };
  return { text:`Valabil până la ${dataExpirare} (${zile} zile)`, culoare:'#1a7a3a' };
}

// Fișa șoferului - situația curentă (nu istoricul complet), formatată pentru print, aceleași
// date care se văd deja în accordionul din tab-ul "Conducători Auto".
function printFisaSofer(sf, det) {
  const categorii = [
    { id:'Permis_Auto', label:'🪪 Permis Auto' },
    { id:'Vizita_Medicala', label:'🩺 Vizite Medicale' },
    { id:'ADR', label:'☢️ Acreditări ADR' },
    { id:'CPC', label:'📜 Atestat CPC' },
    { id:'Tahograf', label:'💳 Card Tahograf' },
  ];
  const randuri = categorii.map(c => {
    const st = statusTextDinData(det?.[c.id]);
    return `<tr><td class="lbl">${c.label}</td><td style="color:${st.culoare};font-weight:bold">${st.text}</td></tr>`;
  }).join('');
  const amenziNr = det?.amenziNumar ?? 0;
  const amenziTotal = fmt(det?.amenziTotal);
  const html = `
    <html><head><title>Fișă șofer — ${sf.username}</title>
    <style>
      @page { size: A4; margin: 16mm; }
      body{font-family:Arial,sans-serif;font-size:13px;color:#111}
      h2{text-align:center;margin-bottom:2px}
      .sub{text-align:center;color:#555;margin-bottom:18px;font-size:12px}
      table{width:100%;border-collapse:collapse;margin-bottom:16px}
      td,th{border:1px solid #999;padding:6px 8px;text-align:left}
      .lbl{background:#f0f0f0;font-weight:bold;width:220px}
      @media print{button{display:none}}
    </style></head><body>
    <h2>FIȘĂ ȘOFER</h2>
    <div class="sub">Generat: ${new Date().toLocaleString('ro-RO')}</div>
    <table>
      <tr><td class="lbl">Șofer</td><td><b>${sf.username}</b></td></tr>
      <tr><td class="lbl">Email</td><td>${sf.email||'—'}</td></tr>
      <tr><td class="lbl">Vehicul asignat</td><td>${sf.nrInmatriculareAsignat||'—'}</td></tr>
    </table>
    <table>
      ${randuri}
      <tr><td class="lbl">🚨 Amenzi</td><td style="color:${parseInt(amenziNr)>0?'#c0392b':'#1a7a3a'};font-weight:bold">${amenziNr} amenzi — total ${amenziTotal} RON</td></tr>
    </table>
    <script>window.onload=()=>window.print()</script>
    </body></html>`;
  const w = window.open('', '_blank');
  w.document.write(html); w.document.close();
}

export default function PersonalTab() {
  const isDriver = (localStorage.getItem('rol') || '') === 'conducator_auto';
  const [tab, setTab] = useState('soferi');
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [soferi, setSoferi] = useState([]);
  const [nruri, setNruri] = useState([]);
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState(EMPTY);
  const [filters, setFilters] = useState({});
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [sort, setSort] = useState({ col:'dataDoc', dir:'desc' });
  const [selectedRow, setSelectedRow] = useState(null);
  const [pulseId, setPulseId] = useState(null);
  const [pulseKey, setPulseKey] = useState(0);
  const [reinnoireModal, setReinnoireModal] = useState(null);
  const [reinnoireForm, setReinnoireForm] = useState({});
  const username = localStorage.getItem('username') || '';

  // --- Tab "Conducători Auto" (roster + fișă) ---
  const [expandedSofer, setExpandedSofer] = useState({});
  const [detaliiSofer, setDetaliiSofer] = useState({});
  const [loadingSoferi, setLoadingSoferi] = useState(false);

  useEffect(() => {
    api.get('/api/auto/nruri').then(r=>setNruri(r.data.map(x=>x.nrInmatriculare)));
    api.get('/api/personal/soferi').then(r=>setSoferi(r.data));
  }, []);

  const loadSoferi = useCallback(() => {
    setLoadingSoferi(true);
    api.get('/api/personal/soferi').then(r=>setSoferi(r.data)).finally(()=>setLoadingSoferi(false));
  }, []);

  const toggleSofer = (sf) => {
    const willOpen = !expandedSofer[sf.username];
    setExpandedSofer(prev => ({ ...prev, [sf.username]: willOpen }));
    if (willOpen && !detaliiSofer[sf.username]) {
      api.get(`/api/personal/soferi/${encodeURIComponent(sf.username)}/detalii`)
        .then(r => setDetaliiSofer(prev => ({ ...prev, [sf.username]: r.data })))
        .catch(() => setDetaliiSofer(prev => ({ ...prev, [sf.username]: null })));
    }
  };

  // --- Tab-uri de documente (Vizite medicale / ADR / CPC / Tahograf / Amenzi) ---
  const load = useCallback(() => {
    if (tab === 'soferi') { loadSoferi(); return; }
    setLoading(true); setSelectedRow(null); setPulseId(null);
    api.get(`/api/personal/documente?categorie=${tab}`).then(r=>setRows(r.data)).finally(()=>setLoading(false));
  }, [tab, loadSoferi]);

  useEffect(() => { load(); setFilters({}); setDateFrom(''); setDateTo(''); }, [load]);

  const catInfo = CATEGORII.find(c=>c.id===tab);
  const setFilter = (col,val) => setFilters(prev=>({...prev,[col]:val}));
  const toggleSort = (col) => setSort(prev=>({col,dir:prev.col===col&&prev.dir==='asc'?'desc':'asc'}));
  const sortIcon = (col) => sort.col===col?(sort.dir==='asc'?' ▲':' ▼'):' ⇅';

  const filtered = rows.filter(r=>{
    if (dateFrom && r.dataDoc && r.dataDoc < dateFrom) return false;
    if (dateTo && r.dataDoc && r.dataDoc > dateTo) return false;
    return Object.entries(filters).every(([col,val])=>!val||String(r[col]||'').toLowerCase().includes(val.toLowerCase()));
  });

  const sorted = [...filtered].sort((a,b)=>{
    const av=String(a[sort.col]||''), bv=String(b[sort.col]||'');
    return sort.dir==='asc'?av.localeCompare(bv):bv.localeCompare(av);
  });

  const totalValoare = filtered.reduce((s,r)=>s+parseFloat(r.valoare||0),0);

  // Documente active (fara bifa de inlocuit) din categoria curenta, pentru selectorul
  // "Inlocuieste documentul" - calculat direct din randurile deja incarcate.
  const activeDocs = rows.filter(r => !esteInlocuit(r) && !(modal?.mode==='edit' && r.nrCrt===modal.id));

  const selectRow = (row) => {
    const isSel = selectedRow?.nrCrt === row.nrCrt;
    if (isSel) { setSelectedRow(null); setPulseId(null); return; }
    setSelectedRow(row);
    const parinte = rows.find(r => parseInt(r.inlocuita) === row.nrCrt);
    setPulseId(parinte ? parinte.nrCrt : null);
    setPulseKey(k => k+1);
  };

  const openAdd = () => { setForm({ ...EMPTY }); setModal({mode:'add'}); };
  const openEdit = (row) => { setForm({...row}); setModal({mode:'edit', id:row.nrCrt}); };

  const save = async () => {
    if (modal.mode==='add') {
      if (!form.username || !String(form.nrDocument||'').trim() || !form.dataDoc ||
          (catInfo.areExpirare && !form.dataExpirare) ||
          (tab==='Permis_Auto' && !form.categoriePermis)) {
        toast('Completează câmpurile obligatorii (Șofer, Nr. document, Dată' +
          (catInfo.areExpirare?', Data expirare':'') +
          (tab==='Permis_Auto'?', Categorie permis':'') + ').', 'error');
        return;
      }
    }
    try {
      const payload = {...form, categorie:tab, operare:username};
      if (modal.mode==='add') await api.post('/api/personal/documente', payload);
      else await api.put(`/api/personal/documente/${modal.id}`, payload);
      setModal(null); load();
      toast(modal.mode==='add'?'Înregistrare adăugată!':'Înregistrare actualizată!');
    } catch(e) { toast('Eroare: '+(e.response?.data?.error||e.message),'error'); }
  };

  const del = async (id) => {
    if (!window.confirm('Ștergi înregistrarea?')) return;
    try { await api.delete(`/api/personal/documente/${id}`); load(); toast('Înregistrare ștearsă!'); }
    catch(e) { toast('Eroare la ștergere','error'); }
  };

  const openReinnoire = (row) => {
    setReinnoireForm({ nrDocument:'', dataDoc:'', dataExpirare:'', valoare:'' });
    setReinnoireModal(row);
  };

  const saveReinnoire = async () => {
    try {
      await api.post(`/api/personal/documente/${reinnoireModal.nrCrt}/reinnoire`,
        { ...reinnoireForm, operare: username });
      setReinnoireModal(null);
      load();
      toast('Document reînnoit cu succes!');
    } catch(e) { toast('Eroare: '+(e.response?.data?.error||e.message),'error'); }
  };

  // Cand aleg un document de inlocuit din lista, blochez si precompletez Sofer / Auto
  const onSelectInlocuieste = (id) => {
    if (!id) { setForm({...form, inlocuita:''}); return; }
    const doc = activeDocs.find(d => String(d.nrCrt)===String(id));
    if (doc) setForm({...form, inlocuita:id, username:doc.username, nrInmatriculare:doc.nrInmatriculare||''});
    else setForm({...form, inlocuita:id});
  };
  const inlocuiesteBlocat = modal?.mode==='add' && !!form.inlocuita;

  const SH = ({col,children}) => (
    <th onClick={()=>toggleSort(col)} style={{cursor:'pointer',userSelect:'none',whiteSpace:'nowrap'}}>
      {children}{sortIcon(col)}
    </th>
  );

  const numeleSoferilor = soferi.map(s=>s.username);

  return (
    <div>
      <div className="tabs">
        <button className={`tab-btn ${tab==='soferi'?'active':''}`} onClick={()=>setTab('soferi')}>🧑‍✈️ Conducători Auto</button>
        {CATEGORII.map(c=>(
          <button key={c.id} className={`tab-btn ${tab===c.id?'active':''}`} onClick={()=>setTab(c.id)}>{c.label}</button>
        ))}
      </div>

      {tab === 'soferi' ? (
        loadingSoferi ? <Spinner/> : (
          <div style={{overflowX:'auto'}}>
            <table>
              <thead>
                <tr>
                  <th>Șofer</th><th>Email</th><th>Vehicul asignat</th>
                  <th>🪪 Permis</th><th>🩺 Viz. medicală</th><th>☢️ ADR</th><th>📜 CPC</th><th>💳 Tahograf</th><th>🚨 Amenzi</th>
                </tr>
              </thead>
              <tbody>
                {soferi.map(sf => {
                  const isExpanded = !!expandedSofer[sf.username];
                  const det = detaliiSofer[sf.username];
                  return (
                    <React.Fragment key={sf.username}>
                      <tr onClick={()=>toggleSofer(sf)} style={{cursor:'pointer',background:isExpanded?'#e8f0fe':undefined}}>
                        <td><b>{isExpanded?'▼ ':'▶ '}{sf.username}</b></td>
                        <td>{sf.email}</td>
                        <td>{sf.nrInmatriculareAsignat || '—'}</td>
                        <td colSpan={6} style={{color:'#888',fontSize:12}}>
                          {isExpanded ? '' : '(click pentru detalii)'}
                        </td>
                      </tr>
                      {isExpanded && (
                        <tr>
                          <td colSpan={9} style={{padding:0}} onClick={e=>e.stopPropagation()}>
                            {!det ? <div style={{padding:16}}><Spinner/></div> : (
                              <div style={{margin:'8px 12px 16px',padding:14,background:'#f7f9ff',borderRadius:8,border:'1px solid #c0d0e8',display:'flex',gap:16,flexWrap:'wrap',alignItems:'center'}}>
                                <div><div style={{fontSize:11,color:'#888',marginBottom:3}}>🪪 Permis</div>{badgeDinData(det.Permis_Auto)}</div>
                                <div><div style={{fontSize:11,color:'#888',marginBottom:3}}>🩺 Viz. medicală</div>{badgeDinData(det.Vizita_Medicala)}</div>
                                <div><div style={{fontSize:11,color:'#888',marginBottom:3}}>☢️ ADR</div>{badgeDinData(det.ADR)}</div>
                                <div><div style={{fontSize:11,color:'#888',marginBottom:3}}>📜 CPC</div>{badgeDinData(det.CPC)}</div>
                                <div><div style={{fontSize:11,color:'#888',marginBottom:3}}>💳 Tahograf</div>{badgeDinData(det.Tahograf)}</div>
                                <div>
                                  <div style={{fontSize:11,color:'#888',marginBottom:3}}>🚨 Amenzi</div>
                                  <span className="badge" style={{background: parseInt(det.amenziNumar)>0 ? '#fde8e8':'#e8f8ee', color: parseInt(det.amenziNumar)>0 ? '#c0392b':'#1a7a3a'}}>
                                    {det.amenziNumar} ({fmt(det.amenziTotal)} RON)
                                  </span>
                                </div>
                                <div style={{marginLeft:'auto'}}>
                                  <button className="btn btn-sm" style={{background:'#555',color:'white'}}
                                    onClick={()=>printFisaSofer(sf, det)}>🖨️ Fișă șofer</button>
                                </div>
                              </div>
                            )}
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  );
                })}
                {soferi.length===0 && <tr><td colSpan={9} style={{textAlign:'center',padding:20,color:'#888'}}>Niciun șofer înregistrat (rol „conducător auto")</td></tr>}
              </tbody>
            </table>
          </div>
        )
      ) : (
      <>
      <div style={{background:'#f7f9fc',padding:'8px 14px',borderBottom:'1px solid #e0e8f0',display:'flex',gap:8,alignItems:'center',flexWrap:'wrap'}}>
        <span style={{fontSize:12,fontWeight:'bold',color:'#555',whiteSpace:'nowrap'}}>Perioadă:</span>
        <input type="date" value={dateFrom} onChange={e=>setDateFrom(e.target.value)}
          style={{padding:'4px 8px',fontSize:12,border:'1px solid #ccc',borderRadius:4,width:150}}/>
        <span style={{color:'#888'}}>—</span>
        <input type="date" value={dateTo} onChange={e=>setDateTo(e.target.value)}
          style={{padding:'4px 8px',fontSize:12,border:'1px solid #ccc',borderRadius:4,width:150}}/>
        {(dateFrom||dateTo) && <button className="btn btn-sm" style={{background:'#eee'}} onClick={()=>{setDateFrom('');setDateTo('');}}>✕</button>}
        <div style={{marginLeft:'auto',display:'flex',gap:6,alignItems:'center'}}>
          <span style={{fontSize:12,color:'#555'}}>{filtered.length} înreg.</span>
          <span style={{fontWeight:'bold',color:'#1a3a5c',fontSize:12}}>Total: {fmt(totalValoare)} RON</span>
          <button className="btn btn-sm" style={{background:'#217346',color:'white'}} onClick={()=>exportCSV(sorted,tab.toLowerCase())}>📊 CSV</button>
          <button className="btn btn-sm" style={{background:'#555',color:'white'}} onClick={()=>printTable(catInfo.label,sorted)}>🖨️</button>
          {!isDriver && selectedRow && <button className="btn btn-warning btn-sm" onClick={()=>openEdit(selectedRow)}>✏️ Modifică</button>}
          {!isDriver && selectedRow && catInfo.areExpirare && !esteInlocuit(selectedRow) &&
            <button className="btn btn-sm" style={{background:'#2d6ca2',color:'white'}} onClick={()=>openReinnoire(selectedRow)}>🔄 Reînnoire</button>}
          {!isDriver && selectedRow && <button className="btn btn-danger btn-sm" onClick={()=>del(selectedRow.nrCrt)}>🗑️</button>}
          {!isDriver && <button className="btn btn-success btn-sm" onClick={openAdd}>+ Adaugă</button>}
        </div>
      </div>

      {loading?<Spinner/>:(
        <div style={{overflowX:'auto'}}>
          <table>
            <thead>
              <tr>
                <SH col="username">Șofer</SH>
                <SH col="nrInmatriculare">Nr. Auto</SH>
                <SH col="nrDocument">Nr. Document</SH>
                {tab==='Permis_Auto' && <SH col="categoriePermis">Categorie</SH>}
                <SH col="dataDoc">{tab==='Permis_Auto' ? 'Data obținerii' : 'Data'}</SH>
                {catInfo.areExpirare && <SH col="dataExpirare">Expiră</SH>}
                {catInfo.areExpirare && <th>Zile rămase</th>}
                <SH col="valoare">Valoare (RON)</SH>
                {tab==='Amenda' && <SH col="termenPlata">Termen de plată</SH>}
                {tab==='Amenda' && <SH col="valoareFinala">Valoare finală (RON)</SH>}
                <th>Descriere</th>
                {catInfo.areExpirare && <th>Înlocuit</th>}
              </tr>
              <tr style={{background:'#f0f4fa'}}>
                <th>
                  <select value={filters.username||''} onChange={e=>setFilter('username',e.target.value)}
                    style={{width:'100%',padding:'3px 6px',fontSize:11,border:'1px solid #ccc',borderRadius:3}}>
                    <option value="">Toți</option>
                    {numeleSoferilor.map(n=><option key={n} value={n}>{n}</option>)}
                  </select>
                </th>
                <th>
                  <select value={filters.nrInmatriculare||''} onChange={e=>setFilter('nrInmatriculare',e.target.value)}
                    style={{width:'100%',padding:'3px 6px',fontSize:11,border:'1px solid #ccc',borderRadius:3}}>
                    <option value="">Toate</option>
                    {nruri.map(n=><option key={n} value={n}>{n}</option>)}
                  </select>
                </th>
                <th><FilterInput value={filters.nrDocument||''} onChange={v=>setFilter('nrDocument',v)}/></th>
                {tab==='Permis_Auto' && <th></th>}
                <th></th>
                {catInfo.areExpirare && <th></th>}
                {catInfo.areExpirare && <th></th>}
                <th></th>
                {tab==='Amenda' && <th></th>}
                {tab==='Amenda' && <th></th>}
                <th></th>
                {catInfo.areExpirare && <th></th>}
              </tr>
            </thead>
            <tbody>
              {sorted.map(r=>{
                const esteInl = esteInlocuit(r);
                const zile = catInfo.areExpirare && r.dataExpirare && !esteInl
                  ? Math.round((new Date(r.dataExpirare)-new Date())/86400000)
                  : null;
                const isSel = selectedRow?.nrCrt === r.nrCrt;
                const doPuls = pulseId === r.nrCrt;
                return (
                  <tr key={r.nrCrt} onClick={()=>selectRow(r)}
                    className={esteInl ? '' : zileColor(zile)}
                    style={{cursor:'pointer',background:isSel?'#e8f0fe':(esteInl?'#f8f8f8':undefined),outline:isSel?'2px solid #2d6ca2':'none',opacity:esteInl?0.6:1}}>
                    <td><b>{r.username}</b></td>
                    <td>{r.nrInmatriculare || '—'}</td>
                    <td>{r.nrDocument}</td>
                    {tab==='Permis_Auto' && <td>{r.categoriePermis || '—'}</td>}
                    <td>{r.dataDoc}</td>
                    {catInfo.areExpirare && <td>{r.dataExpirare}</td>}
                    {catInfo.areExpirare && <td>
                      <span key={doPuls?`p${pulseKey}`:'np'} className={doPuls?'pulse-inlocuit':''}>
                        {esteInl
                          ? <span className="badge" style={{background:'#eee',color:'#888'}}>Înlocuit</span>
                          : (zile!==null?badge(zile):'')}
                      </span>
                    </td>}
                    <td style={{textAlign:'right',fontVariantNumeric:'tabular-nums'}}>{fmt(r.valoare)}</td>
                    {tab==='Amenda' && <td>{r.termenPlata || '—'}</td>}
                    {tab==='Amenda' && <td style={{textAlign:'right',fontVariantNumeric:'tabular-nums'}}>{r.valoareFinala ? fmt(r.valoareFinala) : '—'}</td>}
                    <td style={{fontSize:12.5,color:'#555'}}>{r.descriere}</td>
                    {catInfo.areExpirare && <td style={{textAlign:'center'}}>
                      <span key={doPuls?`p2${pulseKey}`:'np2'} className={doPuls?'pulse-inlocuit':''}>
                        {esteInl?'✅':''}
                      </span>
                    </td>}
                  </tr>
                );
              })}
              {sorted.length===0&&<tr><td colSpan={(catInfo.areExpirare?9:7)+(tab==='Permis_Auto'?1:0)+(tab==='Amenda'?2:0)} style={{textAlign:'center',padding:20,color:'#888'}}>Fără date</td></tr>}
            </tbody>
          </table>
        </div>
      )}

      {selectedRow && (
        <div style={{padding:'6px 14px',background:'#e8f0fe',fontSize:12,color:'#1a3a5c',borderTop:'1px solid #c0d0e8'}}>
          Selectat: <b>{selectedRow.username}</b> — {selectedRow.nrDocument} — {selectedRow.dataDoc}
        </div>
      )}

      {modal && (
        <Modal title={modal.mode==='add'?`Adaugă ${catInfo.label}`:`Editează (ID: ${modal.id})`}
          onClose={()=>setModal(null)} onSave={save}>

          {modal.mode==='add' && catInfo.areExpirare && (
            <div className="form-row single" style={{marginBottom:8}}>
              <div className="form-group">
                <label>Înlocuiește documentul</label>
                <select value={form.inlocuita||''} onChange={e=>onSelectInlocuieste(e.target.value)}>
                  <option value="">-- Nu înlocuiește nimic --</option>
                  {activeDocs.map(d=>(
                    <option key={d.nrCrt} value={d.nrCrt}>
                      {d.username} — {d.nrDocument} — expiră: {d.dataExpirare}
                    </option>
                  ))}
                </select>
                {activeDocs.length===0 && (
                  <span style={{fontSize:11,color:'#888'}}>Nu există documente active în această categorie</span>
                )}
              </div>
            </div>
          )}

          <div className="form-row">
            <div className="form-group">
              <label>Șofer<span style={{color:'#e74c3c'}}> *</span></label>
              <select value={form.username||''} disabled={inlocuiesteBlocat}
                onChange={e=>setForm({...form,username:e.target.value})}>
                <option value="">-- Selectează șoferul --</option>
                {numeleSoferilor.map(n=><option key={n} value={n}>{n}</option>)}
              </select>
            </div>
            <div className="form-group">
              <label>Nr. Auto (opțional)</label>
              <select value={form.nrInmatriculare||''} disabled={inlocuiesteBlocat}
                onChange={e=>setForm({...form,nrInmatriculare:e.target.value})}>
                <option value="">-- Fără vehicul --</option>
                {nruri.map(n=><option key={n} value={n}>{n}</option>)}
              </select>
            </div>
          </div>

          <div className="form-row">
            <div className="form-group"><label>Nr. Document<span style={{color:'#e74c3c'}}> *</span></label>
              <input type="text" value={form.nrDocument||''} onChange={e=>setForm({...form,nrDocument:e.target.value})}/>
            </div>
            <div className="form-group"><label>Valoare (RON)</label>
              <input type="number" value={form.valoare||''} onChange={e=>setForm({...form,valoare:e.target.value})}/>
            </div>
          </div>

          {tab === 'Permis_Auto' && (
            <div className="form-row">
              <div className="form-group"><label>Categorie permis<span style={{color:'#e74c3c'}}> *</span></label>
                <select value={form.categoriePermis||''} onChange={e=>setForm({...form,categoriePermis:e.target.value})}>
                  <option value="">--</option>
                  {CATEGORII_PERMIS.map(c=><option key={c} value={c}>{c}</option>)}
                </select>
              </div>
              <div className="form-group"><label>Data de la care e valabil</label>
                <input type="date" value={form.dataValabilitate||''} onChange={e=>setForm({...form,dataValabilitate:e.target.value})}/>
              </div>
            </div>
          )}

          <div className="form-row">
            <div className="form-group"><label>{tab==='Permis_Auto' ? 'Data obținerii categoriei' : 'Data document'}<span style={{color:'#e74c3c'}}> *</span></label>
              <input type="date" value={form.dataDoc||''} onChange={e=>setForm({...form,dataDoc:e.target.value})}/>
            </div>
            {catInfo.areExpirare
              ? <div className="form-group"><label>Data expirare<span style={{color:'#e74c3c'}}> *</span></label>
                  <input type="date" value={form.dataExpirare||''} onChange={e=>setForm({...form,dataExpirare:e.target.value})}/>
                </div>
              : <div className="form-group"><label>Descriere</label>
                  <input type="text" value={form.descriere||''} onChange={e=>setForm({...form,descriere:e.target.value})}/>
                </div>
            }
          </div>

          {tab === 'Amenda' && (
            <div className="form-row">
              <div className="form-group"><label>Termen de plată</label>
                <input type="date" value={form.termenPlata||''} onChange={e=>setForm({...form,termenPlata:e.target.value})}/>
                <span style={{fontSize:11,color:'#888'}}>Data limită pentru plata amenzii cu reducere</span>
              </div>
              <div className="form-group"><label>Valoare finală (RON)</label>
                <input type="number" value={form.valoareFinala||''} onChange={e=>setForm({...form,valoareFinala:e.target.value})}/>
                <span style={{fontSize:11,color:'#888'}}>Suma efectiv plătită/de plătit, după reducere</span>
              </div>
            </div>
          )}

          {catInfo.areExpirare && (
            <div className="form-row single">
              <div className="form-group"><label>Descriere (opțional)</label>
                <input type="text" value={form.descriere||''} onChange={e=>setForm({...form,descriere:e.target.value})}/>
              </div>
            </div>
          )}

          {modal.mode==='edit' && catInfo.areExpirare && (
            <div className="form-row single">
              <div className="form-group">
                <label>Înlocuiește documentul</label>
                <select value={form.inlocuita||''} onChange={e=>setForm({...form,inlocuita:e.target.value})}>
                  <option value="">-- Nu înlocuiește nimic --</option>
                  {activeDocs.map(d=>(
                    <option key={d.nrCrt} value={d.nrCrt}>
                      {d.username} — {d.nrDocument} — expiră: {d.dataExpirare}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          )}
          <div className="form-row single"><span style={{fontSize:11,color:'#888'}}>* Câmp obligatoriu</span></div>
        </Modal>
      )}

      {reinnoireModal && (
        <Modal title={`Reînnoire — ${catInfo.label} (${reinnoireModal.username})`}
          onClose={()=>setReinnoireModal(null)} onSave={saveReinnoire} saveLabel="Reînnoiește">

          <div style={{background:'#f0f4fa',padding:'8px 12px',borderRadius:4,marginBottom:12,fontSize:12,color:'#555'}}>
            Documentul curent (<b>{reinnoireModal.nrDocument}</b>, expiră {reinnoireModal.dataExpirare}) va fi marcat ca înlocuit.
            Completează datele noului document de mai jos.
          </div>

          <div className="form-row">
            <div className="form-group"><label>Șofer</label>
              <input type="text" value={reinnoireModal.username} disabled/>
            </div>
            <div className="form-group"><label>Nr. Auto</label>
              <input type="text" value={reinnoireModal.nrInmatriculare||'—'} disabled/>
            </div>
          </div>

          <div className="form-row">
            <div className="form-group"><label>Nr. Document nou<span style={{color:'#e74c3c'}}> *</span></label>
              <input type="text" value={reinnoireForm.nrDocument||''} onChange={e=>setReinnoireForm({...reinnoireForm,nrDocument:e.target.value})}/>
            </div>
            <div className="form-group"><label>Valoare (RON)</label>
              <input type="number" value={reinnoireForm.valoare||''} onChange={e=>setReinnoireForm({...reinnoireForm,valoare:e.target.value})}/>
            </div>
          </div>

          <div className="form-row">
            <div className="form-group"><label>{tab==='Permis_Auto' ? 'Data obținerii categoriei' : 'Data document'}<span style={{color:'#e74c3c'}}> *</span></label>
              <input type="date" value={reinnoireForm.dataDoc||''} onChange={e=>setReinnoireForm({...reinnoireForm,dataDoc:e.target.value})}/>
            </div>
            <div className="form-group"><label>Data expirare<span style={{color:'#e74c3c'}}> *</span></label>
              <input type="date" value={reinnoireForm.dataExpirare||''} onChange={e=>setReinnoireForm({...reinnoireForm,dataExpirare:e.target.value})}/>
            </div>
          </div>

          {tab==='Permis_Auto' && (
            <div className="form-row">
              <div className="form-group"><label>Categorie permis<span style={{color:'#e74c3c'}}> *</span></label>
                <select value={reinnoireForm.categoriePermis??reinnoireModal.categoriePermis??''}
                  onChange={e=>setReinnoireForm({...reinnoireForm,categoriePermis:e.target.value})}>
                  <option value="">--</option>
                  {CATEGORII_PERMIS.map(c=><option key={c} value={c}>{c}</option>)}
                </select>
              </div>
              <div className="form-group"><label>Data de la care e valabil</label>
                <input type="date" value={reinnoireForm.dataValabilitate||''} onChange={e=>setReinnoireForm({...reinnoireForm,dataValabilitate:e.target.value})}/>
              </div>
            </div>
          )}
          <div className="form-row single"><span style={{fontSize:11,color:'#888'}}>* Câmp obligatoriu</span></div>
        </Modal>
      )}
      </>
      )}
    </div>
  );
}
